const template = require('./account-assign-dialog.html.slim')
declare var angular

export class AccountAssignDialog {
  static $inject = ['$rootScope', 'User', 'InvestmentAccount']

  public account: any
  public users: any[]
  public saving: boolean
  public searching: boolean
  public selectedUser: number
  public selected: boolean = false

  private investmentAccountResource
  private userResource
  private rootScope

  private _accountId: number
  private _search: string

  constructor(private $rootScope, private User, private InvestmentAccount) {
    this.rootScope = $rootScope
    this.investmentAccountResource = InvestmentAccount
    this.userResource = User
  }

  get accountId(): number { return this._accountId }
  set accountId(value) {
    this._accountId = value
    if (value !== undefined) {
      this.investmentAccountResource.get({
        id: value
      }, (account) => {
        this.account = account
        this.search = this.account.clientName
      })
    }
  }

  get search(): string { return this._search }
  set search(value) {
    this._search = value
    if ( value !== undefined ) {
      this.searching = true
      this.userResource.query({
        search: value
      }, (users) => {
        this.users = users
        this.searching = false
      })
    }
  }

  public setSelected(user): void {
    this.search = user.name
    this.selectedUser = user.id
    this.selected = true
  }

  public save() {
    this.saving = true
    if (this.accountId && this.selectedUser !== undefined) {
      this.InvestmentAccount.update({
        id: this.accountId,
        assign_to_user_id: this.selectedUser,
      }, () => {
        this.rootScope.$emit('refreshAccountsList')
        this.hideDialog()
      })
    }
  }

  public cancel() {
    this.hideDialog()
  }

  public hideDialog(): void {
    // Reset all the things
    this.selected = undefined
    this.selectedUser = undefined
    this.account = undefined
    this.accountId = undefined
    this.saving = false
    this.rootScope.$emit('closeDialog')
  }
}

angular.module('wbComponents').directive('accountAssignDialog', function() {
  return {
    restrict: 'AE',
    require: '^^wbDialog',
    templateUrl: template,
    controller: AccountAssignDialog,
    controllerAs: 'ctrl',
    bindToController: true,
    scope: {
      accountId: '=',
    }
  }
})
